<script lang="ts">
  const rootScope = window["$rootScope"] || false;
  const user = rootScope && rootScope.user;

  let visible = false;

  if (user) visible = user.group_director;
</script>

{#if visible}
  <slot />
{/if}
